import { SubmitHandler } from "react-hook-form";
import { ITenantWizardFormModel } from "../models/tenantWizardFormModel";
import { useTenantWizardForm } from "./useTenantWizardForm";
import { endpointsMetadata } from "../../../../../common/infrastructure/routes/endpointsMetadata";
import { useNavigate, useParams } from "react-router-dom";
import {
  constructTenantHref,
  routePaths,
} from "../../../../../common/infrastructure/routes/routePaths";
import { PageMode } from "../../../../../common/types";
import { useApiQuery } from "../../../../../common/infrastructure/hooks/useApiQuery";
import { useApiMutation } from "../../../../../common/infrastructure/hooks/useApiMutation";
import { normalizePhone } from "../../../../../common/components/forms/inputs/phoneField/utils/PhoneInputUtility";
import { useAppContext } from "../../../../../AppContext";
import { useMemo } from "react";
import { dateUtility } from "../../../../../common/infrastructure/utilities/dateUtility";

export const useTenantWizardPage = (pageMode: PageMode) => {
  const navigate = useNavigate();
  const { isDesktopOrTablet } = useAppContext();

  const { mutate: mutate } = useApiMutation();

  const { id } = useParams();

  const { data: result } = useApiQuery<ITenantWizardFormModel>({
    queryKey: [endpointsMetadata.tenant.wizardGetTenant, id],
    endpoint: `${endpointsMetadata.tenant.wizardGetTenant}?tenantId=${id}`,
    enabled: id !== undefined,
  });

  const policyLastUpdatedOn = useMemo(
    () => dateUtility.formatDate(result?.policyLastModified),
    [result]
  );

  const form = useTenantWizardForm(result);

  const isEdit = pageMode === "edit";
  const pageTitle = `${isEdit ? "Редактиране" : "Добавяне"} на бизнес клиент`;

  const actionButtonLabel = isEdit ? "Редактиране" : "Добавяне";

  const onSave: SubmitHandler<ITenantWizardFormModel> = async (data) => {
    if (data.phoneNumber) {
      data.phoneNumber = normalizePhone(data.phoneNumber)!;
    }
    mutate(
      {
        endpoint: endpointsMetadata.tenant.wizard,
        globalIsLoading: true,
        method: "post",
        invalidateKeys: [
          [endpointsMetadata.tenant.getAll],
          [endpointsMetadata.studio.getStudioSettings],
        ],
        ...data,
      },
      {
        onSuccess: () => {
          if (id) {
            navigate(constructTenantHref(Number(id)));
          } else {
            navigate(routePaths.studioAdd);
          }
        },
      }
    );
  };

  return {
    form,
    actionButtonLabel,
    pageTitle,
    isEdit,
    isDesktopOrTablet,
    policyLastUpdatedOn,
    onSave,
  };
};
